export { addTelemetryDebug, addTelemetryError, startFakeTelemetry, resetTelemetry, startTelemetry, isTelemetryReplicationAllowed, addTelemetryConfiguration, addTelemetryUsage, drainPreStartTelemetry, } from './telemetry';
export * from './rawTelemetryEvent.types';
export * from './telemetryEvent.types';
//# sourceMappingURL=index.js.map